



const GET_SPECIFIC_NOTE = 'notes/GET_SPECIFIC_NOTE';
const MOST_RECENT_NOTES = 'notes/MOST_RECENT_NOTES';
const CREATE_NOTE = 'notes/CREATE_NOTE';
const UPDATE_NOTE = 'notes/UPDATE_NOTE';
const DELETE_NOTE = 'notes/DELETE_NOTE';


export {
  GET_SPECIFIC_NOTE,
  MOST_RECENT_NOTES,
  CREATE_NOTE,
  UPDATE_NOTE,
  DELETE_NOTE,


}
